import React from 'react';
import { Box, Button, Heading, Stack, Wrap, WrapItem } from '@chakra-ui/react';
import { STRAPI_COMPONENT } from '../../utils/logbookLayout';
import { toPlainText } from '../../utils/toPlainText';
import LogbookEmbedBlock from './LogbookEmbedBlock';
import { renderBlocksRichText, stableJsonKey } from './richTextBlocks';

const TEXT_BLOCK = 'logbook.text-block';
const LINKS_BLOCK = 'logbook.links-block';

/**
 * @param {{
 *   blocks: unknown[];
 *   embedVariant?: 'default'|'socialHeavy';
 *   blockKeyPrefix?: string;
 *   stackMt?: number | string;
 * }} props
 */
const LogbookContentBlocks = ({
  blocks,
  embedVariant = 'default',
  blockKeyPrefix = 'cb',
  stackMt = 10,
}) => {
  if (!Array.isArray(blocks) || !blocks.length) return null;

  return (
    <Stack spacing={8} mt={stackMt}>
      {blocks.map((block, i) => {
        const key = stableJsonKey(blockKeyPrefix, { ...block, i });
        const component = block?.[STRAPI_COMPONENT] || '';

        if (component === TEXT_BLOCK) {
          return (
            <Box key={key}>
              {toPlainText(block.heading) ? (
                <Heading as="h2" size="md" color="#3b235a" mb={3}>
                  {toPlainText(block.heading)}
                </Heading>
              ) : null}
              {renderBlocksRichText(block.text || [])}
            </Box>
          );
        }

        if (component === 'logbook.embed-block') {
          return (
            <LogbookEmbedBlock
              key={key}
              provider={block.provider}
              url={block.url}
              caption={block.caption}
              variant={embedVariant}
            />
          );
        }

        if (component === LINKS_BLOCK) {
          return (
            <Box key={key}>
              {toPlainText(block.heading) ? (
                <Heading as="h2" size="md" color="#3b235a" mb={3}>
                  {toPlainText(block.heading)}
                </Heading>
              ) : null}
              <Wrap spacing={2}>
                {(block.links || []).map((item) => (
                  <WrapItem
                    key={
                      item.url || item.documentId || stableJsonKey('lnk', item)
                    }
                  >
                    <Button
                      as="a"
                      href={toPlainText(item.url) || '#'}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="sm"
                      variant="outline"
                      colorScheme="blue"
                      borderRadius="full"
                      borderColor="#36a9e1"
                      color="#36a9e1"
                      _hover={{ bg: 'blue.50' }}
                    >
                      {toPlainText(item.label) ||
                        toPlainText(item.url) ||
                        'Link'}
                    </Button>
                  </WrapItem>
                ))}
              </Wrap>
            </Box>
          );
        }

        return null;
      })}
    </Stack>
  );
};

export default LogbookContentBlocks;
